import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
  },
  textField: {
    width: "100%",
    "& + & ": {
      marginTop: theme.spacing(1.5),
    },
  },
}));

export default function FormOnEditListUsers(props) {
  const classes = useStyles();
  const { open, fetchAPI, editData, handleClose, stateOption } = props;
  const [onError, setOnError] = useState(true);
  const { handleSubmit, errors } = useForm();
  const [editDatas, setEditDatas] = useState({
    id: "",
    nama_user: "",
    idlayanan: "",
    idrole: "",
  });

  const { nama_user, idlayanan, idrole } = editDatas;

  const onSubmit = async () => {
    await fetchAPI(`edit`, editDatas);
  };

  useEffect(() => {
    if (
      editData?.idlayanan === editDatas?.idlayanan &&
      editData?.idrole === editDatas?.idrole
    ) {
      return setOnError(true);
    }
    return setOnError(false);
  }, [editData, editDatas, onError]);

  useEffect(() => {
    if (editData) {
      setEditDatas({
        id: editData.id,
        nama_user: editData.nama_user,
        idlayanan: editData.idlayanan,
        idrole: editData.idrole,
      });
    }
  }, [editData]);

  const handleFieldChange = (e) =>
    setEditDatas({ ...editDatas, [e.target.name]: e.target.value });

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle id="form-dialog-title">Edit On List Group</DialogTitle>
          <DialogContent>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12}>
                <TextField
                  disabled
                  id="nama_user"
                  name="nama_user"
                  value={nama_user}
                  label="Nama User"
                  type="string"
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  select
                  className={classes.textField}
                  label="Layanan"
                  id="idlayanan"
                  name="idlayanan"
                  defaultValue={idlayanan}
                  fullWidth
                  onChange={handleFieldChange}
                  variant="outlined"
                  required
                >
                  <MenuItem value="none" disabled selected>
                    --Pilih Layanan--
                  </MenuItem>
                  {stateOption.option1 &&
                    stateOption.option1.map((item, i) => (
                      <MenuItem key={i} value={item.id}>
                        {item.nama}
                      </MenuItem>
                    ))}
                </TextField>
                {errors.idlayanan && (
                  <Typography variant="caption" color="error">
                    {errors.idlayanan.message}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  select
                  className={classes.textField}
                  label="Nama Role"
                  id="idrole"
                  name="idrole"
                  defaultValue={idrole}
                  fullWidth
                  onChange={handleFieldChange}
                  variant="outlined"
                  required
                >
                  <MenuItem value="none" disabled selected>
                    --Pilih Role--
                  </MenuItem>
                  {stateOption.option2 &&
                    stateOption.option2.map((item, i) => (
                      <MenuItem key={i} value={item.id}>
                        {item.nama}
                      </MenuItem>
                    ))}
                </TextField>
                {errors.idrole && (
                  <Typography variant="caption" color="error">
                    {errors.idrole.message}
                  </Typography>
                )}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button type="submit" color="primary" disabled={onError}>
              Save
            </Button>
            <Button onClick={handleClose} color="secondary">
              Cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
